import React from 'react';
import { DatePickerCompat as DatePickerCompatNew } from './DatePickerCompat';
import { convertOldDatePickerProps, OldDatePickerProps } from './converter.old';

export type DatePickerProps = OldDatePickerProps;
export type DatePickerCompatProps = DatePickerProps;
export const DatePickerCompat: React.FC<DatePickerProps> = (props) => (
  <DatePickerCompatNew {...convertOldDatePickerProps(props)} />
);
export const DatePicker = DatePickerCompat;
